module.exports = __webpack_public_path__ + "img/rating_helmet_red.b98e904c.svg";